import * as api from '../api/officeInfo';
import {
  createRequestTypes,
  START,
  SUCCESS,
  ERROR,
} from '@modules/appraisal/actions/global';
import { makeApiActionCreatorV3 } from '@actions/utils';

const prefix = 'APPRAISAL-ADMIN/OFFICE-INFO';

export const FETCH_OFFICE_INFO = createRequestTypes(
  `${prefix}/FETCH_OFFICE_INFO`,
);

export const fetchOfficeInfo = makeApiActionCreatorV3(
  api.fetchOfficeInfo,
  FETCH_OFFICE_INFO[START],
  FETCH_OFFICE_INFO[SUCCESS],
  FETCH_OFFICE_INFO[ERROR],
);

export const UPDATE_OFFICE_INFO = createRequestTypes(
  `${prefix}/UPDATE_OFFICE_INFO`,
);

export const updateOfficeInfo = makeApiActionCreatorV3(
  api.updateOfficeInfo,
  UPDATE_OFFICE_INFO[START],
  UPDATE_OFFICE_INFO[SUCCESS],
  UPDATE_OFFICE_INFO[ERROR],
);
